module.exports = __webpack_public_path__ + "static/media/candle.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/candle.png
// module id = 878
// module chunks = 0